import React, { useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputNumber from '../../components/Inputs/InputNumber'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import { TextArea } from '../../components/Inputs/TextArea'
import Datepicker from '../../components/Inputs/Datepicker'
import Select from '../../components/Inputs/Select'
import axios from 'axios'
import Button from '../../components/General/Button'
import { dateToDB, formatPipe, getDenomination } from '../../utils/utils'
import { Employee, IGetPayroll } from './Payroll'
import { ColumnsTable } from 'safe'
import { motion } from 'framer-motion'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { toFixed } from 'accounting'
import { DateTime } from 'luxon'
import CurrencyInput from '../../components/Inputs/CurrencyInput'

const server = process.env.REACT_APP_SERVER_URL
const PaymentForm: React.FC<IPaymentForm> = ({
  bankOptions,
  onCancel,
  onSubmit,
  isLoading,
  payrollInfoSelected,
}) => {
  const form = useForm<any>()

  const [employees, setEmployees] = useState<IEmployeeGeneral[]>(
    payrollInfoSelected.employees.map((v) => ({
      ...v,
      benefitAmount: toFixed(
        v?.benefits.reduce((a, b) => a + +toFixed(+b.amount, 2), 0),
        2
      ),
      deductionAmount: toFixed(
        v?.deductions.reduce((a, b) => a + +toFixed(+b.amount, 2), 0),
        2
      ),
      salary: v?.baseSalary,
    }))
  )

  const [rate, setRate] = useState<{ [key: string]: string } | null>(null)

  const onTotalAmount = useMemo(() => {
    if (!rate) {
      return 0
    }
    return employees?.reduce(
      (a, b) =>
        +toFixed(
          +(
            +toFixed(
              +(+b?.benefitAmount + +b?.salary - +b?.deductionAmount),
              2
            ) * +(b?.currencyId === '2' ? 1 : rate![b?.currencyId])
          ),
          2
        ) + a,
      0
    )
  }, [employees, rate])

  const onSubmitForm = (values: IForm) => {
    onSubmit({
      ...values,
      amount: onTotalAmount,
      date: dateToDB(values?.date),
      employees: employees.map((v) => ({
        id: v?.id,
        amount: +toFixed(
          +toFixed(+v?.salary + +v?.benefitAmount - +v?.deductionAmount, 2) *
            (v?.currencyId === '2' ? 1 : +rate![v?.currencyId]),
          2
        ),
      })),
    })
  }

  const onChangeValue = (key: string, newValue: string, record: Employee) => {
    console.log('NEW VALUE', newValue)
    let localEmployees = [...employees]
    let selectedEmployee = localEmployees.find((v) => v.id === record?.id)!
    selectedEmployee[key] = newValue
    setEmployees(localEmployees)
  }

  const [columns, setColumns] = useState<ColumnsTable[]>([])

  useEffect(() => {
    if (rate) {
      const columns: ColumnsTable[] = [
        {
          title: 'Nombre',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Cédula',
          dataIndex: 'document',
          key: 'document',
        },
        {
          title: 'Salario Base',
          dataIndex: 'baseSalary',
          key: 'baseSalary',
          render: (id: number, record: IEmployeeGeneral) => {
            const currencyRender = (): string => {
              if (record?.currencyId === '1') {
                return '$. num'
              }
              if (record?.currencyId === '2') {
                return 'Bs. num'
              }
              if (record?.currencyId === '3') {
                return '€. num'
              }
              if (record?.currencyId === '4') {
                return 'COP. num'
              }
              return ''
            }

            return (
              <div style={{ width: '70%' }} className="flex flex-row">
                {/* <div className="mt-1">{getDenomination(record.currencyId)}</div>
                <input
                  style={{ width: 80 }}
                  onChange={(e) =>
                    onChangeValue('salary', e.target.value, record)
                  }
                  value={record?.salary}
                  className="cursor-text transition w-3/6 dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                  type="text"
                  min={'1'}
                /> */}
                <CurrencyInput
                  addDecimals={true}
                  mask={currencyRender()}
                  value={record?.salary + ''}
                  onBlur={(value) => {
                    console.log("VALUE", value)
                    onChangeValue('salary', value, record)
                  }}
                />
              </div>
            )
          },
        },
        {
          title: 'Beneficios',
          dataIndex: 'beneficios',
          key: 'beneficios',
          render: (id: number, record: IEmployeeGeneral) => {
            const currencyRender = (): string => {
              if (record?.currencyId === '1') {
                return '$. num'
              }
              if (record?.currencyId === '2') {
                return 'Bs. num'
              }
              if (record?.currencyId === '3') {
                return '€. num'
              }
              if (record?.currencyId === '4') {
                return 'COP. num'
              }
              return ''
            }

            return (
              <div style={{ width: '70%' }} className="flex flex-row">
                {/* <div className="mt-1">{getDenomination(record.currencyId)}</div>
                <input
                  style={{ width: 80 }}
                  // onChange={(e) => onChange(record, e)}
                  value={record?.benefitAmount}
                  className="cursor-text transition w-3/6 dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                  type="text"
                  min={'1'}
                /> */}

                <CurrencyInput
                  addDecimals={true}
                  mask={currencyRender()}
                  value={record?.benefitAmount + ''}
                  onBlur={(value) => {
                    onChangeValue('benefitAmount', value, record)
                  }}
                />

                {/* <InputNumber addDecimals={true} value={+record?.benefitAmount} onChange={(value) => {
                  // console.log("VALUE", value)
                  onChangeValue('benefitAmount', value, record)
                }} /> */}
              </div>
            )
          },
        },
        {
          title: 'Deducciones',
          dataIndex: 'deducciones',
          key: 'deducciones',
          render: (id: number, record: IEmployeeGeneral) => {
            const currencyRender = (): string => {
              if (record?.currencyId === '1') {
                return '- $. num'
              }
              if (record?.currencyId === '2') {
                return '- Bs. num'
              }
              if (record?.currencyId === '3') {
                return '- €. num'
              }
              if (record?.currencyId === '4') {
                return '- COP. num'
              }
              return ''
            }

            return (
              <div style={{ width: '70%' }} className="flex flex-row">
                {/* <div className="mt-1 mr-2">-</div>
                <div className="mt-1">{getDenomination(record.currencyId)}</div>
                <input
                  style={{ width: 80 }}
                  // onChange={(e) => onChange(record, e)}
                  value={record?.deductionAmount}
                  className="cursor-text transition dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
                  type="text"
                  min={'1'}
                /> */}
                {/* <InputNumber addDecimals={true} value={+record?.deductionAmount} /> */}

                <CurrencyInput
                  addDecimals={true}
                  mask={currencyRender()}
                  value={(record.deductionAmount + '')}
                  onBlur={(value) => {
                    onChangeValue('deductionAmount', value, record)
                  }}
                  // onChange={(value) => {
                  //   onChangeValue('deductionAmount', value, record)
                  // }}
                />
              </div>
            )
          },
        },
        {
          title: 'Monto total',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
          render: (id: any, record: IEmployeeGeneral) => (
            <ColumnItemWrapper>
              {`${getDenomination(record?.currencyId)} ${formatPipe(
                +toFixed(+record?.salary, 2) +
                  +toFixed(+record?.benefitAmount, 2) -
                  +toFixed(+record?.deductionAmount, 2) +
                  ''
              )}`}
            </ColumnItemWrapper>
          ),
        },
        {
          title: 'Monto total en Bs.',
          dataIndex: 'montoBs',
          key: 'montoBs',
          render: (id: any, record: IEmployeeGeneral) => (
            <ColumnItemWrapper>
              {`Bs. ${formatPipe(
                toFixed(
                  (+toFixed(+record?.salary, 2) +
                    +toFixed(+record?.benefitAmount, 2) -
                    +toFixed(+record?.deductionAmount, 2)) *
                    +rate![record?.currencyId],
                  2
                ) + ''
              )}`}
            </ColumnItemWrapper>
          ),
        },
      ]

      setColumns(columns)
    }
  }, [rate])

  return (
    <>
      <Form classes="gap-x-5" form={form} onSubmit={onSubmitForm}>
        {/* <FormItem name="amount" classes="col-span-6">
          <InputNumber addDecimals={true} label="Monto" />
        </FormItem> */}

        <h2 className="col-span-12 mb-2 text-primary-900 font-bold">
          {'Pagar nómina'}
        </h2>

        <FormItem
          name="accountId"
          classes="col-span-6"
          defaultValue={bankOptions[0]}
        >
          {/* <RawAutoComplete
          label="Cuenta"
          url={`accounting/simple-search`}
          bodyGet={'accounts'}
          queryParam={'search'}
          selectedValue={undefined}
          setSelectedValue={(value) => {
            console.log('value..', value)
            // setSelectedAccount(value)
          }}
        /> */}

          <Select options={bankOptions} label="Cuenta bancaria de egreso" />
        </FormItem>

        <FormItem name="date" classes="col-span-6">
          <Datepicker
            label="Fecha de pago"
            onChangeDate={async (value) => {
              const inputDate = DateTime.fromFormat(value, 'dd/MM/yyyy')
              const outputDate = inputDate.toFormat('yyyy-MM-dd')
              let response = await axios.get<{ rates: IRate[] }>(
                `${server}/finances/rate?date=${outputDate}&currency=all`
              )
              let ratesValues = response.data.rates.reduce(
                (a: any, b: IRate) => {
                  a[b?.id] = b?.rate
                  return a
                },
                {} as { [key: string]: string }
              )

              setRate(ratesValues)
            }}
          />
        </FormItem>

        <FormItem name="observation" classes="col-span-12">
          <TextArea label="Observaciones" maxLength={255} placeholder="" />
        </FormItem>

        <motion.div
          className="col-span-12 mt-6"
          style={{ maxHeight: 250, overflow: 'auto' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Table data={employees} columns={columns} showPagination={false} />
        </motion.div>

        <div className="col-span-12 mt-3">
          <label>Monto total: Bs. {formatPipe(onTotalAmount + '')}</label>
        </div>

        <div className="col-span-12 h-full flex flex-row mt-5">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                onCancel()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>

          <div className="w-1/2 pr-1">
            <Button
              type="primary"
              loading={isLoading}
              classes="w-full"
              htmlType="submit"
            >
              Pagar
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}

interface IPaymentForm {
  bankOptions: { value: string; text: string }[]
  onSubmit: (values: any) => void
  onCancel: () => void
  isLoading: boolean
  payrollInfoSelected: IGetPayroll
}

export interface IForm {
  accountId: string
  amount: string
  date: string
  observation: string
  employees: { id: string; amount: string }[]
}

interface EmployeeLocal {
  salary: string
  benefitAmount: string
  deductionAmount: string
}

interface IRate {
  id: string
  rate: string
}

type IEmployeeGeneral = Employee & EmployeeLocal

export default PaymentForm
